export function hideMapboxAttribution() {
    const mapboxLogoEl = document.querySelector('a.mapboxgl-ctrl-logo');
    if (mapboxLogoEl) mapboxLogoEl.style.display = 'none';
}
